import { configureStore } from "@reduxjs/toolkit";
import bookingRecordsReducer from "../dux/bookingRecords";
import loginReducer from "../dux/login";
import myBookingsReducer from "../dux/myBookings";
import promptReducer from "../dux/prompt";
import snackbarReducer from "../dux/snackbar";
import apiStatus from "../dux/apiStatus";
import bookNowReducer from "../dux/bookNow";
import myBookingTabReducer from "../dux/myBookingTab";
import uiBookNow from "../dux/ui/uiBookNow";
import markDaysOffHolidayReducer from "../dux/markDaysOffHoliday";

import bookingRecords from "../middleware/bookingRecords";
import apiMiddleware from "../middleware/core/api";
import feedback from "../middleware/feedback";
import login from "../middleware/login";
import myBookings from "../middleware/myBookings";
import profile from "../middleware/profile";
import snackbar from "../middleware/snackbar";
import bookNow from "../middleware/bookNow";
import store from "../middleware/store";
import apiError from "../middleware/core/apiError";
import blockSlot from "../middleware/blockSlot";
import markDaysOffHoliday from "../middleware/markDaysOffHoliday";
import bookingSetting from "../middleware/bookingSetting";
import bookingSettingReducer from "../dux/bookingSetting";
import dayMappingsReducer from "../dux/dayMappings";
import settingsReducer from "../dux/settings";
import activityLogReducer from "../dux/activityLog";
import equipmentConfigReducer from "../dux/equipmentConfig";
import feedbackReducer from "../dux/feedback";
import paymentReconciliationReducer from "../dux/paymentReconciliation";
import user from "../middleware/user";
import admin from "../middleware/admin";
import pricing from "../middleware/pricing";
import payment from "../middleware/payment";
import holidayBooking from "../middleware/holidayBooking";
import dayMappings, { dayMappingsAfterware } from "../middleware/dayMappings";
import settingsMiddleware from "../middleware/settings";
import activityLog from "../middleware/activityLog";
import equipmentConfig from "../middleware/equipmentConfig";

export default configureStore({
  reducer: {
    myBookings: myBookingsReducer,
    markDays: markDaysOffHolidayReducer,
    login: loginReducer,
    prompt: promptReducer,
    snackbar: snackbarReducer,
    bookNow: bookNowReducer,
    bookingRecords: bookingRecordsReducer,
    myBookingTab: myBookingTabReducer,
    bookingSetting: bookingSettingReducer,
    dayMappings: dayMappingsReducer,
    settings: settingsReducer,
    activityLog: activityLogReducer,
    equipmentConfig: equipmentConfigReducer,
    feedback: feedbackReducer,
    paymentReconciliation: paymentReconciliationReducer,
    apiStatus,
    uiBookNow,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          // File download actions that contain Blobs
          "INVOICE_DOWNLOAD API_SUCCESS",
          "INVOICE_DOWNLOAD API_FAILURE",
          "DOWNLOAD_BOOKING_RECORD_CSV API_SUCCESS",
          "DOWNLOAD_BOOKING_RECORD_CSV API_FAILURE",
        ],
        // Ignore these field paths in all actions
        ignoredActionPaths: ["meta.arg", "payload.timestamp"],
        // Ignore these paths in the state
        ignoredPaths: ["bookNow.date"],
      },
      immutableCheck: {
        // Ignore these paths in the state
        ignoredPaths: ["bookNow.date"],
      },
    }).concat([
      markDaysOffHoliday,
      blockSlot,
      store,
      bookNow,
      myBookings,
      profile,
      feedback,
      login,
      snackbar,
      bookingRecords,
      bookingSetting,
      dayMappings,
      settingsMiddleware,
      activityLog,
      equipmentConfig,
      user,
      admin,
      pricing,
      payment,
      holidayBooking,
      apiMiddleware,
      dayMappingsAfterware,
      apiError,
    ]),
});
